module.exports = require("react-pubsub-via-radio.js/RadioServiceMixin");



//////////////////
// WEBPACK FOOTER
// ./~/ES/lib/react-pubsub-via-radio.js/RadioServiceMixin.js
// module id = 18
// module chunks = 0 1 2 3 4